import { useState } from "react"
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  IconButton,
  Button
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import VisibilityIcon from "@mui/icons-material/Visibility"
import EventModal from "../EventModal/EventModal"
import "./NotificationsPanel.css"

export function NotificationsPanel({ isOpen, onClose }) {
  console.log("NotificationsPanel render. isOpen:", isOpen);
  const [selectedEvent, setSelectedEvent] = useState(null)

  const upcomingEvents = [
    { id: 1, title: "Exhibitors Data 2025", date: "April 10, 2025" },
     { id: 1, title: "Exhibitors Data 2025", date: "April 10, 2025" },
    { id: 2, title: "AI Conference", date: "May 5, 2025" },
    { id: 3, title: "Startup Summit", date: "June 15, 2025" }
  ]

  const eventDescriptions = {
    1: "A showcase of top exhibitors in various industries.",
    2: "Join the AI Conference to explore innovations in artificial intelligence.",
    3: "Connect with founders and investors at the Startup Summit."
  }

  const handleOpenModal = (event) => {
    setSelectedEvent(event)
  }

  const handleCloseModal = () => {
    setSelectedEvent(null)
  }

  if (!isOpen) return null

  return (
    <>
      <div className="notification-backdrop" onClick={onClose} />
      <div className="notification-panel">
<Card className="h-full border-0 shadow-none" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <CardHeader className="notification-header">
            {/* Removed header actions */}
          </CardHeader>

          <CardContent className="notification-content">
            <div className="notification-title-box">
              <h2 className="notification-main-title">Notifications</h2>
              <IconButton onClick={onClose} className="icon-btn close-btn" aria-label="close notifications panel">
                <CloseIcon />
              </IconButton>
            </div>
            <div className="event-section">
              <h2 className="event-heading">Upcoming Events</h2>
              <div className="event-list">
                {upcomingEvents.map((event) => (
                  <div key={event.id} className="event-card">
                    <div className="event-info">
                      <h4 className="event-title">{event.title}</h4>
                      <p className="event-date">{event.date}</p>
                    </div>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="view-button"
                      onClick={() => handleOpenModal(event)}
                    >
                      <VisibilityIcon />
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Modal */}
      <EventModal
        open={!!selectedEvent}
        event={selectedEvent}
        description={selectedEvent ? eventDescriptions[selectedEvent.id] : ""}
        onClose={handleCloseModal}
      />
    </>
  )
}
